import React from 'react';
import { business, policies } from '../data/business';
const nav = [{
  label: 'Catalog',
  href: '#catalog'
}, {
  label: 'About',
  href: '#about'
}, {
  label: 'Publisher',
  href: '#authors'
}, {
  label: 'Policies',
  href: '#policies'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Footer() {
  return <footer className="w-full bg-ink text-paper border-t border-white/10" data-id="element-142" data-mp="36q9354utwwr2">
      <div className="mx-auto max-w-6xl px-6 py-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-143" data-mp="3ueimm04kl8f1">
        <div data-id="element-144" data-mp="398zqhbvha9n">
          <p className="font-serif text-2xl" data-id="element-145" data-mp="37o6cv1anxdd">Deleon Publishing LLC</p>
          <p className="text-paper/55 text-sm mt-3 leading-relaxed" data-id="element-146" data-mp="3lem1g8he2roq">
            An independent press dedicated to works of history, philosophy, and
            the spirit.
          </p>
        </div>

        <div data-id="element-147" data-mp="29zgli2s8ywn6">
          <h2 className="text-gold-light text-xs uppercase tracking-[0.3em] mb-4" data-id="element-148" data-mp="29ynk7hc24zcf">
            Explore
          </h2>
          <ul className="space-y-2.5" data-id="element-149" data-mp="2ezbf4e3eq0bx">
            {nav.map(n => <li key={n.href} data-id="element-150" data-mp="3l90lvqkngowm">
                <a href={n.href} className="text-paper/70 hover:text-gold-light transition-colors text-sm tracking-wide" data-id="element-151" data-mp="3labrlvxno6qd">
                  {n.label}
                </a>
              </li>)}
          </ul>
        </div>

        <div data-id="element-152" data-mp="3q8dgwylod2aa">
          <h2 className="text-gold-light text-xs uppercase tracking-[0.3em] mb-4" data-id="element-153" data-mp="3q7u2hrv8gw10">
            Policies
          </h2>
          <ul className="space-y-2.5" data-id="element-154" data-mp="817d85ghpotj">
            {policies.map(p => <li key={p.id} data-id="element-155" data-mp="335rtdvlddew">
                <a href={`#${p.id}`} className="text-paper/70 hover:text-gold-light transition-colors text-sm tracking-wide" data-id="element-156" data-mp="31uoff6267ob">
                  {p.title}
                </a>
              </li>)}
          </ul>
        </div>

        <div data-id="element-157" data-mp="qtrq4dfsnjbp">
          <h2 className="text-gold-light text-xs uppercase tracking-[0.3em] mb-4" data-id="element-158" data-mp="qrf67uqh6yw0">
            Customer Support
          </h2>
          <address className="not-italic text-sm text-paper/70 space-y-2 leading-relaxed" data-id="element-159" data-mp="tvczxt1gc7fo">
            <p data-id="element-160" data-mp="yty0xuoj2v56">
              <a href={`mailto:${business.email}`} className="hover:text-gold-light transition-colors" data-id="element-161" data-mp="yto69tsjfzt5">
                {business.email}
              </a>
            </p>
            <p data-id="element-162" data-mp="18l2d6mmtk1wb">
              <a href={business.phoneHref} className="hover:text-gold-light transition-colors" data-id="element-163" data-mp="18lk6pbi3k20j">
                {business.phone}
              </a>
            </p>
            <p className="text-paper/55" data-id="element-164" data-mp="1hiul35q7o79o">
              {business.address.line2}
              <br data-id="element-165" data-mp="1ml3eu4awrdcu" />
              {business.address.line3}
              <br data-id="element-166" data-mp="1rilet56y6i8p" />
              {business.address.line4}
            </p>
          </address>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-167" data-mp="3obx2lev1v0vx">
        <div className="mx-auto max-w-6xl px-6 py-6 flex flex-col sm:flex-row justify-between gap-2 text-paper/45 text-xs" data-id="element-168" data-mp="3od86deohw8n1">
          <p data-id="element-169" data-mp="2aevf3w32tu7d">
            © {new Date().getFullYear()} {business.legalName}. All rights
            reserved.
          </p>
          <p data-id="element-170" data-mp="25o5cgqm1c5gd">All prices in U.S. Dollars (USD). Secure checkout via Stripe.</p>
        </div>
      </div>
    </footer>;
}